import {Card, CardBody, CardHeader, Col, Input, Row, Button} from "reactstrap";
import {ReactSortable} from "react-sortablejs";
import React, {Fragment, useEffect, useState} from "react";
import dots from "../../../assets/dots.png";
import '../../../@core/scss/react/libs/flatpickr/flatpickr.scss';
import Flatpickr from "react-flatpickr";
import OdaberiEkipuPlayoffModal from "./OdaberiEkipuPlayoffModal";
import OdaberiEkipu3rdPlacePlayoffModal from "./OdaberiEkipu3rdPlacePlayoffModal";
import FastChoiceChooseModal from "../NewCompetition/FastChoiceChooseModal";
import {selectThemeColors} from "../../../utility/Utils";
import {getRandomInt} from "../../../@fake-db/utils";
import axios from "axios";


const PlayoffScreen = (props) => {
    if (props.games == null || props.games.length == 0) {
        return null;
    }

    console.log("Playoff screen props", props)

    let isEdit = props.isEdit;
    const [isChooseTeamModalOpen, setIsChooseTeamModalOpen] = useState(false);
    const [isChoose3rdPlaceTeamModalOpen, setIsChoose3rdPlaceTeamModalOpen] = useState(false)
    const [teamIndex, setTeamIndex] = useState(null);
    const [indexRound, setIndexRound] = useState(null);
    const [gameIndex, setGameIndex] = useState(null);
    const [thirdGameHomeTeam, setThirdGameHomeTeam] = useState(null)
    const [thirdGameAwayTeam, setThirdGameAwayTeam] = useState(null)

    function addGooglePlacesToInputs() {
        let inputs = document.getElementsByClassName("lokacija-natjecanja-input");
        if (inputs.length == 0) {
            return;
        }
        if (inputs[0].classList.contains("pac-target-input")) {
            return;
        }
        for (let i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            const options = {
                fields: ["address_components", "geometry", "icon", "name"],
            };
            const autocomplete = new google.maps.places.Autocomplete(input, options);
            autocomplete.addListener("place_changed", () => {
                let newGames = [...props.games];
                let elements = input.id.split("_");
                let place = autocomplete.getPlace();
                place.fullName = input.value;
                newGames[elements[0]][elements[1]].location = place;
                props.setGames([...newGames]);
            });
        }
    }

    let handleGooglePlaces = () => {
        let inputs = document.getElementsByClassName("lokacija-natjecanja-input");
        let numberOfGames = 0;
        for (let i = 0; i < props.numberOfRounds.length; i++) {
            numberOfGames = numberOfGames + Math.pow(2, i);
        }
        if (document.getElementById("search-script-google-playoff") != null || inputs.length < numberOfGames) {
            console.log("return")
            return;
        }
        let myScript = document.createElement("script");
        myScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBLJTaZ8EX8QV22uA6qis_wKpT-dZbmad8&libraries=places&callback=initMap";
        myScript.onload = () => {
            addGooglePlacesToInputs(inputs);
        }
        myScript.className = 'search-script';
        myScript.id = 'search-script-google-playoff';
        console.log("appended")
        document.body.appendChild(myScript);
    }


    useEffect(() => {
        function initMap(e) {
        }
    }, [])


    handleGooglePlaces();
    if (document.getElementById("search-script-google-playoff") != null && window.google != null) {
        addGooglePlacesToInputs();
    }

    console.log(props.games);

    return (
        <>
        <Row className="flex-nowrap" style={{overflowX: "scroll"}}>
            <OdaberiEkipuPlayoffModal
                games={props.games}
                setGames={props.setGames}
                teamIndex={teamIndex}
                indexRound={indexRound}
                gameIndex={gameIndex}
                allTeams={props.allTeams}
                setAllTeams={props.setAllTeams}
                toggle={() => {
                    setIsChooseTeamModalOpen(!isChooseTeamModalOpen);
                }}
                isOpen={isChooseTeamModalOpen}
            />
            
            {

            props.numberOfRounds.map((element, indexRound) => {
             
                let numberOfGamesArray = [...Array(Math.trunc(props.getNumberOfGamesInARound(indexRound + 1))).keys()];
                console.log("Number of games array", numberOfGamesArray)
                return (
                    <Col className={"my-auto justify-content-center align-content-center text-center"}>
                        {numberOfGamesArray.map((element, index) => {
                            let setCustomGamesSwap = (id1, id2) => {
                                if (!id1 || !id2) {
                                    return;
                                }
                                let team1swap = null;
                                let team2swap = null;
                                let index1swap = null;
                                let index1swapTeam = null;
                                let index2swap = null;
                                let index2swapTeam = null;
                                let newGames = [...props.games];
                                newGames[indexRound].map((singleGame, gameIndex) => {
                                    if (singleGame.teams && singleGame.teams.length == 2) {
                                        if (singleGame.teams[0]._id == id1) {
                                            team1swap = singleGame.teams[0];
                                            index1swap = gameIndex;
                                            index1swapTeam = 0;
                                        }
                                        if (singleGame.teams[1]._id == id1) {
                                            team1swap = singleGame.teams[1];
                                            index1swap = gameIndex;
                                            index1swapTeam = 1;
                                        }
                                        if (singleGame.teams[0]._id == id2) {
                                            team2swap = singleGame.teams[0];
                                            index2swap = gameIndex;
                                            index2swapTeam = 0;
                                        }
                                        if (singleGame.teams[1]._id == id2) {
                                            team2swap = singleGame.teams[1];
                                            index2swap = gameIndex;
                                            index2swapTeam = 1;
                                        }
                                    }
                                });
                                if (team1swap !== null && team2swap !== null) {
                                    newGames[indexRound][index1swap].teams[index1swapTeam] = team2swap;
                                    newGames[indexRound][index2swap].teams[index2swapTeam] = team1swap;
                                }

                                props.setGames([...newGames]);
                            }
                            return (
                                <Card style={{margin: "15px"}}>
                                    <div
                                         style={{width: "250px", backgroundColor: "whitesmoke", borderRadius: "8px", boxShadow: "1px 1px 5px 1px grey", cursor: "pointer"}}>
                                        <CardHeader className={"justify-content-center"}>
                                            
                                        </CardHeader>
                                        <CardBody>
                                            {props.games[indexRound][index].teams && props.games[indexRound][index].teams.map((team, myIndex) => {
                                                let domId = team ? team._id : null;
                                                if (!domId) {
                                                    domId = indexRound + "_" + index + "_" + myIndex + "_custom";
                                                }
                                                return (
                                                    <div
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            let myGame = {};
                                                            myGame.game = props.games[indexRound][index]
                                                        }}
                                                        id={domId}
                                                        key={domId}>
                                                        <div
                                                            style={{border: "1px solid grey", borderRadius: "24px"}}
                                                            onClick={(e) => {
                                                                /* if (indexRound !== 0) {
                                                                    return;
                                                                } */
                                                                e.stopPropagation()
                                                                setTeamIndex(myIndex)
                                                                setIndexRound(indexRound)
                                                                setGameIndex(index)
                                                                setTimeout(() => {
                                                                    setIsChooseTeamModalOpen(true)
                                                                }, 0)
                                                            }}
                                                            id={domId}
                                                            draggable={indexRound === 0 && !isEdit}
                                                            onDragStart={(e) => {
                                                                e.dataTransfer.setData("dragId", e.target.id);
                                                            }}
                                                            onDragOver={(e) => {
                                                                e.preventDefault(); // Necessary. Allows us to drop.
                                                                return false;
                                                            }}
                                                            onDrop={(e) => {
                                                                if (indexRound !== 0) {
                                                                    return;
                                                                }
                                                                let fromId = e.dataTransfer.getData("dragId");
                                                                let toId = e.target.id;
                                                                if (!toId.includes("_custom")) {
                                                                    setCustomGamesSwap(fromId, toId);
                                                                } else {
                                                                    let allTeamsCustom = [...props.allTeams];
                                                                    let teamToFilter = null
                                                                    allTeamsCustom = allTeamsCustom.filter((customTeam) => {
                                                                        if (customTeam._id === fromId) {
                                                                            teamToFilter = customTeam;
                                                                            return false;
                                                                        }
                                                                        return true;
                                                                    })
                                                                    props.setAllTeams([...allTeamsCustom]);
                                                                    if (teamToFilter !== null) {
                                                                        let elements = toId.split("_")
                                                                        let newGames = [...props.games];
                                                                        newGames[elements[0]][elements[1]].teams[elements[2]] = teamToFilter;
                                                                        props.setGames([...newGames]);
                                                                    }
                                                                }
                                                            }}
                                                            className={"row justify-content-center align-content-center single-team"}>
                                                            <Col md='3' id={domId}>
                                                                {!isEdit && indexRound === 0 &&
                                                                <img style={{
                                                                    width: "12px",
                                                                    height: "12px"
                                                                }} className={"my-auto"} src={dots}/>
                                                                }
                                                            </Col>
                                                            <Col md={"9"} id={domId}>
                                                                <span
                                                                    id={domId}> {(team && team.shortName) ? team.shortName : ((team && team.name) ? team.name : (indexRound !== 0 ? "?" : ""))} {(team && team.surname) ? team.surname : ""}</span>
                                                            </Col>
                                                        </div>
                                                        {myIndex === 0 &&
                                                        <Fragment>
                                                            <Flatpickr
                                                                options={{
                                                                    time_24hr: true,
                                                                    "time-24hr": true,
                                                                    "time24hr": true,
                                                                    "data-time-24hr": true,
                                                                    "data-time-24-hr": true,
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    margin: "5px 20px 20px",
                                                                    height: "20px",
                                                                    width: "150px",
                                                                    border: "none",
                                                                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                                                                }}
                                                                placeholder={"Datum i vrijeme"}
                                                                draggable="false"
                                                                data-enable-time
                                                                id='range-picker'
                                                                className="form-control single-team"
                                                                value={props.games[indexRound][index].date}
                                                                onChange={(date) => {
                                                                    let newGames = [...props.games];
                                                                    newGames[indexRound][index].date = date;
                                                                    console.log("Date change new games", newGames)
                                                                    props.setGames([...newGames]);
                                                                }}
                                                            />
                                                            <Input
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    margin: "5px 20px 20px",
                                                                    height: "20px",
                                                                    width: "150px",
                                                                    border: "none",
                                                                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                                                                }}
                                                                id={indexRound + "_" + index + "_custom" + getRandomInt(1, 1000000000)}
                                                                theme={selectThemeColors}
                                                                placeholder={"Lokacija"}
                                                                className='lokacija-natjecanja-input'
                                                                classNamePrefix='select'
                                                                value={(props.games[indexRound][index].location && props.games[indexRound][index].location.fullName) ? props.games[indexRound][index].location.fullName : props.games[indexRound][index].location}
                                                                onChange={(event) => {
                                                                    let newGames = [...props.games];
                                                                    newGames[indexRound][index].location = event.target.value;
                                                                    props.setGames([...newGames]);
                                                                }}
                                                                name='clear'
                                                                isClearable={false}
                                                            />
                                                        </Fragment>
                                                        }
                                                    </div>
                                                );
                                            })}
                                        </CardBody>
                                    </div>
                                </Card>
                            );
                        })}
                    

                    </Col>
                );
            })
            }

            {
            /*
            =============================================================================================================================
            FOLLOWING CODE NON EXISTANT
            =============================================================================================================================
             */
             }

            {false && props.numberOfRounds.map((element, indexRound) => {
                indexRound = props.numberOfRounds.length - indexRound - 1;
                let numberOfGamesArray = [...Array(props.getNumberOfGamesInARound(indexRound + 1)).keys()];
                return (
                    <Col className={"my-auto justify-content-center align-content-center text-center"}>
                        {numberOfGamesArray.map((element, index) => {
                            let setCustomGamesSwap = (id1, id2) => {
                                if (!id1 || !id2) {
                                    return;
                                }
                                let team1swap = null;
                                let team2swap = null;
                                let index1swap = null;
                                let index1swapTeam = null;
                                let index2swap = null;
                                let index2swapTeam = null;
                                let newGames = [...props.games];
                                newGames[indexRound].map((singleGame, gameIndex) => {
                                    console.log(singleGame);
                                    if (singleGame.teams && singleGame.teams.length == 2) {
                                        console.log("ulaz u loop");
                                        if (singleGame.teams[0]._id == id1) {
                                            team1swap = singleGame.teams[0];
                                            index1swap = gameIndex;
                                            index1swapTeam = 0;
                                        }
                                        if (singleGame.teams[1]._id == id1) {
                                            team1swap = singleGame.teams[1];
                                            index1swap = gameIndex;
                                            index1swapTeam = 1;
                                        }
                                        if (singleGame.teams[0]._id == id2) {
                                            team2swap = singleGame.teams[0];
                                            index2swap = gameIndex;
                                            index2swapTeam = 0;
                                        }
                                        if (singleGame.teams[1]._id == id2) {
                                            team2swap = singleGame.teams[1];
                                            index2swap = gameIndex;
                                            index2swapTeam = 1;
                                        }
                                    }
                                });
                                if (team1swap !== null && team2swap !== null) {
                                    newGames[indexRound][index1swap].teams[index1swapTeam] = team2swap;
                                    newGames[indexRound][index2swap].teams[index2swapTeam] = team1swap;
                                }

                                props.setGames([...newGames]);
                            }
                            return (
                                <Card style={{margin: "15px"}}>
                                    <div onClick={() => {
                                    }}
                                         style={{width: "250px", backgroundColor: "whitesmoke", cursor: "pointer"}}>
                                        <CardHeader className={"justify-content-center"}>
                                        </CardHeader>
                                        <CardBody>
                                            {indexRound != 0 && (props.games[indexRound][index].teams[0] == null || props.games[indexRound][index].teams[0].length === 0) &&
                                            <Fragment>
                                                <div
                                                    className={"row justify-content-center align-content-center single-team"}>
                                                    ?
                                                </div>
                                                <Flatpickr
                                                    style={{
                                                        backgroundColor: "white",
                                                        margin: "5px",
                                                        marginLeft: "10px",
                                                        marginRight: "10px",
                                                        marginBottom: "10px",
                                                        height: "25px"
                                                    }}
                                                    draggable="false"
                                                    data-enable-time
                                                    id='range-picker'
                                                    className="form-control"
                                                    value={new Date()}
                                                    onChange={(date) => {
                                                        let newGames = [...props.games];
                                                        newGames[indexRound][index].date = date;
                                                        props.setGames([...newGames]);
                                                    }}
                                                />
                                                <div
                                                    className={"row justify-content-center align-content-center single-team"}>
                                                    ?
                                                </div>
                                            </Fragment>
                                            }
                                            {props.games[indexRound][index].teams && props.games[indexRound][index].teams.map((team, myIndex) => {
                                                let domId = team._id;
                                                if (!domId) {
                                                    domId = indexRound + "_" + index + "_" + myIndex + "_custom";
                                                }
                                                return (
                                                    <Fragment
                                                        id={domId}
                                                        key={domId}>
                                                        <div
                                                            id={domId}
                                                            draggable={"true"}
                                                            onDragStart={(e) => {
                                                                e.dataTransfer.setData("dragId", e.target.id);
                                                            }}
                                                            onDragOver={(e) => {
                                                                e.preventDefault(); // Necessary. Allows us to drop.
                                                                return false;
                                                            }}
                                                            onDrop={(e) => {
                                                                let fromId = e.dataTransfer.getData("dragId");
                                                                let toId = e.target.id;
                                                                if (!toId.includes("_custom")) {
                                                                    setCustomGamesSwap(fromId, toId);
                                                                } else {
                                                                    let allTeamsCustom = [...props.allTeams];
                                                                    let teamToFilter = null
                                                                    allTeamsCustom = allTeamsCustom.filter((customTeam) => {
                                                                        if (customTeam._id === fromId) {
                                                                            teamToFilter = customTeam;
                                                                            return false;
                                                                        }
                                                                        return true;
                                                                    })
                                                                    props.setAllTeams([...allTeamsCustom]);
                                                                    if (teamToFilter !== null) {
                                                                        let elements = toId.split("_")

                                                                        let newGames = [...props.games];
                                                                        newGames[elements[0]][elements[1]].teams[elements[2]] = teamToFilter;
                                                                        props.setGames([...newGames]);
                                                                    }
                                                                }
                                                            }}
                                                            className={"row justify-content-center align-content-center single-team"}>
                                                            <Col md='3' id={domId}>
                                                                <img style={{
                                                                    width: "12px",
                                                                    height: "12px"
                                                                }} className={"my-auto"} src={dots}/>
                                                            </Col>
                                                            <Col md={"9"} id={domId}>
                                                                <span id={domId}> {team.name ? team.name : ""}</span>
                                                            </Col>
                                                        </div>
                                                        {myIndex === 0 &&
                                                        <Flatpickr
                                                            style={{
                                                                backgroundColor: "white",
                                                                margin: "5px",
                                                                marginLeft: "10px",
                                                                marginRight: "10px",
                                                                marginBottom: "10px",
                                                                height: "25px"
                                                            }}
                                                            draggable="false"
                                                            data-enable-time
                                                            id='range-picker'
                                                            className="form-control single-team"
                                                            value={new Date()}
                                                            onChange={(date) => {
                                                                let newGames = [...props.games];
                                                                newGames[indexRound][index].date = date;
                                                                props.setGames([...newGames]);
                                                            }}
                                                        />

                                                        }
                                                    </Fragment>
                                                );
                                            })}

                                            {indexRound != 0 &&
                                            <div className='list-group sortable'>
                                                {props.games[indexRound][index].teams && props.games[indexRound][index].teams.map((team) => {
                                                    return (
                                                        <div key={team._id}
                                                             className={"row justify-content-center align-content-center team-container-playoff"}>
                                                            {team ? team.name : ""}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            }
                                        </CardBody>
                                    </div>
                                </Card>
                            );
                        })}
                    </Col>
                );
            })}
        </Row>
        {
         props.isThirdPlaceGame &&
         
        <Row>
            <OdaberiEkipu3rdPlacePlayoffModal
            allTeams={props.allTeams}
            setAllTeams={props.setAllTeams}
            gameThirdPlace={props.gameThirdPlace}
            setGameThirdPlace={props.setGameThirdPlace}
            thirdGameHomeTeam={thirdGameHomeTeam}
            setThirdGameHomeTeam={setThirdGameHomeTeam}
            thirdGameAwayTeam={thirdGameAwayTeam}
            setThirdGameAwayTeam={setThirdGameAwayTeam}
            toggle={() => {
                setIsChoose3rdPlaceTeamModalOpen(!isChoose3rdPlaceTeamModalOpen)
            }}
            isOpen={isChoose3rdPlaceTeamModalOpen}
            />

         
        <Col className={"my-auto justify-content-center align-content-center text-center"}>
            <h3>Utakmica za 3. mjesto</h3>

            <Card className={"align-items-center"} style={{margin: "15px"}}>
                                    <div
                                         style={{width: "250px", backgroundColor: "whitesmoke", borderRadius: "8px", boxShadow: "1px 1px 5px 1px grey", cursor: "pointer"}}>
                                        <CardHeader className={"justify-content-center"}>
                                            
                                        </CardHeader>
                                        <CardBody>
                                            {
                                                    <div
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            
                                                        }}
                                                        id="gameThirdPlace"
                                                        key="gameThirdPlace">
                                                        <div
                                                            style={{border: "1px solid grey", borderRadius: "24px"}}
                                                            onClick={(e) => {
                                                                
                                                               console.log("Clicked team")
                                                               setIsChoose3rdPlaceTeamModalOpen(true)
                                                               setThirdGameHomeTeam(props.gameThirdPlace.homeTeam ? props.gameThirdPlace.homeTeam : "clicked")
                                                            }}
                                                            id="gameThirdPlace"
                                                          
                                                           
                                                            className={"row justify-content-center align-content-center single-team"}>
                                                            <Col md='3' id="gameThirdPlacee">
                                                            </Col>
                                                            <Col md={"9"} id="gameThirdPlace">
                                                                <span
                                                                    id="gameThirdPlace"> 
                                                                    {
                                                                    props.gameThirdPlace.homeTeam?.shortName ||
                                                                    props.gameThirdPlace.homeTeam?.name
                                                                    }
                                                                    </span>
                                                            </Col>
                                                        </div>
                                                        <Fragment>
                                                            <Flatpickr
                                                                options={{
                                                                    time_24hr: true,
                                                                    "time-24hr": true,
                                                                    "time24hr": true,
                                                                    "data-time-24hr": true,
                                                                    "data-time-24-hr": true,
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    margin: "5px 20px 20px",
                                                                    height: "20px",
                                                                    width: "150px",
                                                                    border: "none",
                                                                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                                                                }}
                                                                placeholder={"Datum i vrijeme"}
                                                                draggable="false"
                                                                data-enable-time
                                                                id='range-picker'
                                                                className="form-control single-team"
                                                                defaultValue={props.gameThirdPlace.date}
                                                                onChange={(date) => {
                                                                    props.setGameThirdPlace({...props.gameThirdPlace, date})
                                                                }}
                                                            />
                                                            <Input
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    margin: "5px 20px 20px",
                                                                    height: "20px",
                                                                    width: "150px",
                                                                    border: "none",
                                                                    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                                                                }}
                                                                id="thirdPlace-location-picker"
                                                                theme={selectThemeColors}
                                                                placeholder={"Lokacija"}
                                                                className='location-3rd-place'
                                                                classNamePrefix='select'
                                                                defaultValue={props.gameThirdPlace.location}
                                                                onChange={(event) => {
                                                                    props.setGameThirdPlace({
                                                                        ...props.gameThirdPlace, 
                                                                        location: event.target.value
                                                                    })
                                                                }}
                                                                name='clear'
                                                                isClearable={false}
                                                            />
                                                        </Fragment>
                                                        <div
                                                            style={{border: "1px solid grey", borderRadius: "24px"}}
                                                            onClick={(e) => {
                                                                
                                                               console.log("Clicked team")
                                                               setIsChoose3rdPlaceTeamModalOpen(true)
                                                               setThirdGameAwayTeam(props.gameThirdPlace.awayTeam ? props.gameThirdPlace.awayTeam : "clicked")
                                                            }}
                                                            id="gameThirdPlace"
                                                          
                                                           
                                                            className={"row justify-content-center align-content-center single-team"}>
                                                            <Col md='3' id="gameThirdPlacee">
                                                            </Col>
                                                            <Col md={"9"} id="gameThirdPlace">
                                                                <span
                                                                    id="gameThirdPlace"> 
                                                                    {
                                                                        props.gameThirdPlace.awayTeam?.shortName ||
                                                                        props.gameThirdPlace.awayTeam?.name
                                                                    }
                                                                    </span>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                
                                            }
                                        </CardBody>
                                    </div>
                                </Card>
            </Col>
        </Row>
    }
        </>
    );
}

export default PlayoffScreen;